import Fetch from '../Fetch';

export default {
  queryStatistics: (params) => {
    return Fetch.get(`/api/v1/port_statistics`, { params });
  },
  clearStatistics: (params) => {
    return Fetch.post(`/api/v1/port_stats_reset`, params);
  }
};
